import React, { FC } from 'react';
import { Typography } from '@material-ui/core';

import { formatPrice } from 'common/utils';

interface IPriceCellProps {
  content: string | number;
  bold?: boolean;
  isPrimaryOverColor?: boolean;
}

const PriceCell: FC<IPriceCellProps> = ({ content, bold, isPrimaryOverColor }) => {
  const getContentColor = () => {
    if (Number(content) < 0) {
      return 'error';
    } else if (Number(content) === 0) {
      return 'textPrimary';
    } else {
      return isPrimaryOverColor ? 'primary' : 'textPrimary';
    }
  };

  return content !== null ? (
    <Typography
      component="span"
      variant={bold ? 'h5' : 'body1'}
      style={{ whiteSpace: 'nowrap', textAlign: 'right' }}
      color={getContentColor()}
    >
      {formatPrice(content)}
    </Typography>
  ) : null;
};

export default PriceCell;
